module.exports = __webpack_public_path__ + "static/media/009.0a8d6529.jpeg";